import * as React from 'react';
import { INormalizedUGCLabel } from '../../../helpers/labels';
import { __ } from '../../../helpers/TranslationService';
import { LabelBox } from '../../../components/LabelBox/LabelBox';

let style: any = {
    bottomSectionWrapper: {
        backgroundColor: '#f0f0f0',
    },
    title: {
        padding: '6px 0px 0px 8px',
        fontSize: '13px',
    },
    labelsWrapper: {
        paddingLeft: '8px',
        listStyle: 'none',
        display: 'flex',
        margin: '5px 0px 8px',
        overflow: 'hidden',
        maxWidth: '100%',
        flexWrap: 'wrap',
        maxHeight: '25px',
        flexDirection: 'row',
    },
    labelItemWrapper: {
        marginRight: '3px',
        wordBreak: 'none',
        wordWrap: 'none',
        whiteSpace: 'nowrap',
    },
};

export class SearchResultItemBottomSection extends React.Component<{
    ugcLabels: INormalizedUGCLabel[];
}> {
    render() {
        const { ugcLabels } = this.props;
        if (!ugcLabels || !ugcLabels.length) {
            return null;
        }
        return (
            <div style={style.bottomSectionWrapper}>
                <div style={style.title}>{__('Thats what our customers say', 'dreamlines')}:</div>
                <div style={style.labelsWrapper}>
                    {ugcLabels?.map((textLabel, index) => {
                        return (
                            <li style={style.labelItemWrapper} key={index}>
                                <LabelBox
                                    type={textLabel.label}
                                    label={__(textLabel.label, 'dreamlines')}
                                />
                            </li>
                        );
                    })}
                </div>
            </div>
        );
    }
}
